import React from 'react';
import {CloseButton, Col, Row} from "react-bootstrap";

import styles from './SampleDataPage.module.css';
import {Field, getIn} from "formik";

const InputSampleForm = (props) => {
    const {index, onDelete, values, setFieldValue, errors, touched} = props;
    const currentQuantity = values.sampleItems[index].quantity;

    const decreaseQuantity = () => {
        if (currentQuantity > 0) {
            setFieldValue(`sampleItems.${index}.quantity`, currentQuantity - 1);
        }
    }

    const increaseQuantity = () => {
        setFieldValue(`sampleItems.${index}.quantity`, currentQuantity + 1);
    }

    return <>
        <div className={'mt-5'}>
            <h6>Nama Barang</h6>
            <Row>
                <Col lg={10}>
                    <Field name={`sampleItems.${index}.itemName`}
                           className={'form-control'}
                           placeholder={'Contoh: Kentang Dieng AB'}/>
                </Col>
                <Col lg={2}>
                    {values.sampleItems.length > 1 && <CloseButton onClick={() => onDelete(index)}/>}
                </Col>
            </Row>
            {getIn(errors, `sampleItems.${index}.itemName`) &&
                getIn(touched, `sampleItems.${index}.itemName`) === true &&
                <p className={styles.invalidMessage}>
                    {getIn(errors, `sampleItems.${index}.itemName`)}
                </p>
            }
        </div>
        <div className={'mt-3'}>
            <Row>
                <Col lg={4}>
                    <h6>Qty</h6>
                    <Row>
                        <Col lg={3} className={'pt-1'}>
                            <div className={`${styles.circle} ${currentQuantity > 0 ? styles.circleActive : styles.circleInactive}`}
                                 onClick={decreaseQuantity}>
                                -
                            </div>
                        </Col>
                        <Col lg={6}>
                            <Field name={`sampleItems.${index}.quantity`}
                                   className={'form-control text-center'}
                                   type={'number'} step="0.01"
                                   placeholder={0}
                                   min={0}
                                   value={getIn(values, `sampleItems.${index}.quantity`) ?? Math.abs(getIn(values, `sampleItems.${index}.quantity`))}
                                   onChange={(e) => setFieldValue(`sampleItems.${index}.quantity`, parseFloat(e.target.value))}
                                   />
                        </Col>
                        <Col lg={2} className={'pt-1'}>
                            <div className={`${styles.circle} ${styles.circleActive}`}
                                 onClick={increaseQuantity}>
                                +
                            </div>
                        </Col>
                    </Row>
                    {getIn(errors, `sampleItems.${index}.quantity`) &&
                        getIn(touched, `sampleItems.${index}.quantity`) === true &&
                        <p className={styles.invalidMessage}>
                            {getIn(errors, `sampleItems.${index}.quantity`)}
                        </p>
                    }
                    {getIn(errors, `sampleItems.${index}.unit`) &&
                        getIn(touched, `sampleItems.${index}.unit`) === true &&
                        <p className={styles.invalidMessage}>
                            {getIn(errors, `sampleItems.${index}.unit`)}
                        </p>
                    }
                </Col>
                <Col lg={6}>
                    <h6>Unit</h6>
                    <Field name={`sampleItems.${index}.unit`}
                           className={'form-control'}
                           placeholder={'Contoh: Gram'}/>
                </Col>
            </Row>
        </div>
    </>
}

export default InputSampleForm;